import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "my-record-top" }
const _hoisted_3 = { class: "my-record-top-container" }
const _hoisted_4 = { class: "my-record-top-intro" }
const _hoisted_5 = { class: "my-record-top-title" }
const _hoisted_6 = { class: "my-records" }
const _hoisted_7 = { class: "my-record-item hospital-visit-item" }
const _hoisted_8 = {
  key: 0,
  class: "speech-balloon hospital-visit-balloon"
}
const _hoisted_9 = { class: "speech-balloon-content" }
const _hoisted_10 = { class: "balloon-header" }
const _hoisted_11 = { class: "balloon-title" }
const _hoisted_12 = { class: "balloon-text" }
const _hoisted_13 = { class: "my-record-item-header-title" }
const _hoisted_14 = { class: "my-record-item-header-title-text" }
const _hoisted_15 = { class: "my-record-item-body" }
const _hoisted_16 = {
  key: 0,
  class: "my-record-item-body-unrecorded"
}
const _hoisted_17 = { class: "hospital-visit-detail" }
const _hoisted_18 = { class: "hospital-visit-detail-datetime" }
const _hoisted_19 = { class: "hospital-visit-detail-datetime-date" }
const _hoisted_20 = {
  key: 0,
  class: "hospital-visit-detail-datetime-time"
}
const _hoisted_21 = { class: "hospital-visit-detail-label" }
const _hoisted_22 = { class: "hospital-visit-hospital-name" }
const _hoisted_23 = { class: "hospital-visit-appendix" }
const _hoisted_24 = { class: "hospital-visit-appendix-update" }
const _hoisted_25 = { class: "my-record-item" }
const _hoisted_26 = { class: "my-record-item-header-title" }
const _hoisted_27 = { class: "my-record-item-header-title-text" }
const _hoisted_28 = { class: "my-record-item-body" }
const _hoisted_29 = {
  key: 0,
  class: "my-record-item-body-unrecorded"
}
const _hoisted_30 = { class: "treatment-medicine-name" }
const _hoisted_31 = { class: "treatment-disease" }
const _hoisted_32 = { class: "treatment-disease" }
const _hoisted_33 = { class: "treatment-detail" }
const _hoisted_34 = { class: "treatment-detail-type" }
const _hoisted_35 = { class: "treatment-detail-type-text" }
const _hoisted_36 = {
  key: 0,
  class: "treatment-medicine-name"
}
const _hoisted_37 = {
  key: 1,
  class: "treatment-disease"
}
const _hoisted_38 = { class: "treatment-appendix" }
const _hoisted_39 = { class: "treatment-appendix-period" }
const _hoisted_40 = { class: "treatment-appendix-period-text" }
const _hoisted_41 = { class: "treatment-appendix-period-date" }
const _hoisted_42 = {
  key: 0,
  class: "treatment-appendix-period-text"
}
const _hoisted_43 = { class: "treatment-appendix-period-date" }
const _hoisted_44 = { class: "treatment-appendix-update" }
const _hoisted_45 = { class: "my-record-switch" }
const _hoisted_46 = { class: "my-record-top-container" }
const _hoisted_47 = { class: "my-record-top-title" }
const _hoisted_48 = { class: "my-records" }
const _hoisted_49 = { class: "my-record-item diagnosis-process" }
const _hoisted_50 = { class: "diagnosis-process-first-time" }
const _hoisted_51 = { class: "my-record-item-header-title" }
const _hoisted_52 = { class: "my-record-item-header-title-text" }
const _hoisted_53 = { class: "my-record-item-body" }
const _hoisted_54 = { class: "diagnosis-process-list" }
const _hoisted_55 = { class: "diagnosis-process-list-item-label" }
const _hoisted_56 = {
  key: 0,
  src: "/server/necs/images/icon_check_diagnosis_process.svg",
  alt: ""
}
const _hoisted_57 = { class: "diagnosis-process-list-item-disease" }
const _hoisted_58 = { class: "diagnosis-process-appendix" }
const _hoisted_59 = { class: "diagnosis-process-appendix-text" }
const _hoisted_60 = { class: "my-record-item" }
const _hoisted_61 = { class: "my-record-item-header exercise-routine-header" }
const _hoisted_62 = { class: "my-record-item-header-title" }
const _hoisted_63 = { class: "my-record-item-header-title-text" }
const _hoisted_64 = { class: "pc-only" }
const _hoisted_65 = { class: "my-record-item-body" }
const _hoisted_66 = {
  key: 0,
  class: "my-record-item-body-unrecorded"
}
const _hoisted_67 = { class: "exercise-routine-name" }
const _hoisted_68 = { class: "exercise-routine-update" }
const _hoisted_69 = {
  key: 0,
  id: "healthcaredata02-00-c"
}
const _hoisted_70 = { class: "modal my-record-popup" }
const _hoisted_71 = { class: "modal-header" }
const _hoisted_72 = { class: "modal-body" }
const _hoisted_73 = { class: "popup-contents" }
const _hoisted_74 = ["src"]
const _hoisted_75 = { class: "popup-contents-title" }
const _hoisted_76 = { class: "popup-contents-text" }
const _hoisted_77 = { class: "modal-footer" }
const _hoisted_78 = { class: "modal-footer-buttons" }

import dayjs from "dayjs";
import "dayjs/locale/ja";

import { ref, onMounted, reactive, computed } from "vue";
import { useRouter } from "vue-router";
import { _$t } from "@/utils/i18n";

import ErrorDialog from "@/views/base/CommonMessage.vue";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import ExerciseHabitModal from "@/views/pages/MyRecord/ExerciseHabit/ExerciseHabitModal.vue";
import { MyRecord } from "@/models/myRecord";
import {
  Diagnosis,
  ExerciseHabit,
  HospitalVisit,
  Treatment,
  TreatmentStatus,
} from "@/models/myRecord/clinicNote/types";
import { processend, processing } from "@/utils/view";

type Option = {
  option_id: number;
  value: number;
  kubun: string;
  display_name: string;
};

const activeMenu = "my-record";
const componentId = "healthcaredata02-00";

const MAX_TREATMENT_DISPLAY_COUNT = 1;

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

dayjs.locale("ja");

const router = useRouter();
const showSpeechBalloon = ref(false);
const isInitialized = ref(false);
const infoModal = reactive({
  show: false,
  title: "",
  content: "",
  image: "",
  open: (name: string) => {
    if (name === "treatment") {
      infoModal.title = _$t("myRecord_heading_title_treatment");
      infoModal.content = _$t("myRecord_popup_label_content_treatment");
      infoModal.image = "/server/necs/images/image_treatment-data_help.png";
    } else {
      infoModal.title = _$t("myRecord_heading_title_basic");
      infoModal.content = _$t("myRecord_popup_label_content_basic");
      infoModal.image = "/server/necs/images/my_record_basic_info_popup.png";
    }
    infoModal.show = true;
  },
  close: () => {
    infoModal.show = false;
    infoModal.title = "";
    infoModal.content = "";
    infoModal.image = "";
  },
});
const hospitalVisit = ref<HospitalVisit | null>();
const treatment = ref<Treatment | null>();
const treatmentsCount = ref<number>(0);
const diagnosis = ref<Diagnosis[] | null>();
const exerciseHabit = ref<ExerciseHabit | null>();
const exerciseHabitText = ref("");
const sessionErr = ref(false);
const showExerciseHabitModal = ref(false);
const treatmentStatusOptions = ref<Option[]>([]);

const hasMoreTreatments = computed(
  () => (treatmentsCount.value ?? 0) > MAX_TREATMENT_DISPLAY_COUNT
);

const hiddenTreatmentCount = computed(() => {
  const total = treatmentsCount.value ?? 0;
  return Math.max(total - MAX_TREATMENT_DISPLAY_COUNT, 0);
});

const errorDialog = reactive({
  show: false,
  okButtonHide: true,
  okName: _$t("survey_msg_ok_btn"),
  safe: true,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

const goTo = (route: string) => {
  router.push({
    name: route,
  });
};

const goToClinicNote = () => {
  if (!hospitalVisit.value?.hospitalVisitId) return;

  router.push({
    name: "ClinicNote",
    params: {
      hospitalVisitId: hospitalVisit.value.hospitalVisitId,
    },
  });
};

const handleExerciseHabitModalOpen = () => {
  showExerciseHabitModal.value = true;
};

const handleExerciseHabitModalClose = () => {
  showExerciseHabitModal.value = false;
};

function getTreatmentStatusOption(status: string | number): Option {
  if (typeof status === "number") {
    return treatmentStatusOptions.value.find((s) => s.value === status)!;
  } else {
    return treatmentStatusOptions.value.find((s) => s.display_name === status)!;
  }
}

const shouldShowStatusChangedDate = (statusValue?: TreatmentStatus) => {
  return (
    statusValue === TreatmentStatus.Suspend ||
    statusValue === TreatmentStatus.Finish
  );
};

const getStatusChangedDateLabel = (statusValue?: TreatmentStatus) => {
  return statusValue === TreatmentStatus.Suspend
    ? _$t("treatment_label_status_suspend")
    : _$t("treatment_label_end");
};

const getStatusChangedDateText = (t: Treatment | null | undefined) => {
  const date = t?.suspensionDate;
  if (date === undefined || date === null) {
    return _$t("treatment_label_no_date");
  }
  return dayjs(date).format("YYYY年M月D日");
};

const fetchMyRecords = async () => {
  const myRecord = new MyRecord();
  const [_collection, response, err] = await myRecord.getMyRecords();
  if (err) {
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    const status = err.error?.response?.status;
    if (status === 408) {
      // セッションエラー
      sessionErr.value = true;
    }
    errorDialog.open(decodedMessage);
    return;
  }
  hospitalVisit.value = response.data.hospitalVisit;
  if (!hospitalVisit.value) showSpeechBalloon.value = true;
  treatment.value = response.data.treatment;
  treatmentsCount.value = response.data.treatmentCount;
  diagnosis.value = response.data.diagnosis;
  exerciseHabit.value = response.data.exerciseRoutine;
  exerciseHabitText.value =
    response.data.exerciseRoutine?.exerciseRoutine ?? "";
  treatmentStatusOptions.value = response.data.treatmentStatusOptions;
  isInitialized.value = true;
};

onMounted(() => {
  fetchMyRecords();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, { "active-menu": activeMenu }),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[8] || (_cache[8] = _createElementVNode("img", { src: "/server/necs/images/icon_heart_smile.svg" }, null, -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("myRecord_card_label_info")), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("myRecord_heading_title_treatment")), 1),
                _createElementVNode("img", {
                  src: "/server/necs/images/icon_info.svg",
                  alt: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (infoModal.open('treatment')))
                })
              ])
            ])
          ]),
          (isInitialized.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (showSpeechBalloon.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _cache[9] || (_cache[9] = _createElementVNode("img", {
                                src: "/server/necs/images/light_bulb.svg",
                                class: "balloon-icon"
                              }, null, -1)),
                              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("myRecord_popup_label_title")), 1)
                            ]),
                            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("myRecord_popup_label_text")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "my-record-item-header",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (goTo('HospitalVisit')))
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[10] || (_cache[10] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_hospital.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("myRecord_card_title_hospital_visit")), 1)
                      ]),
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "my-record-item-header-arrow" }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      (!hospitalVisit.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t("myRecord_card_label_hospital_visit_initial")), 1))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("p", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString(hospitalVisit.value?.visitDate
                          ? _unref(dayjs)(hospitalVisit.value.visitDate).format("M月D日(dd)")
                          : _ctx.$t("hospitalVisit_card_text_date_not_confirmed")), 1),
                                (hospitalVisit.value?.visitTime)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(dayjs)(hospitalVisit.value.visitTime).format("HH:mm")) + "～", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("p", _hoisted_21, _toDisplayString(hospitalVisit.value.purpose), 1)
                            ]),
                            _createElementVNode("p", _hoisted_22, _toDisplayString(hospitalVisit.value.hospitalName), 1),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("button", {
                                class: "hospital-visit-appendix-link",
                                onClick: goToClinicNote
                              }, [
                                _cache[12] || (_cache[12] = _createElementVNode("img", {
                                  src: "/server/necs/images/icon_link_hospital_visits.svg",
                                  alt: ""
                                }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("myRecord_popup_label_check")), 1)
                              ]),
                              _createElementVNode("p", _hoisted_24, [
                                _cache[13] || (_cache[13] = _createElementVNode("img", {
                                  src: "/server/necs/images/icon_update_time.svg",
                                  alt: ""
                                }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(hospitalVisit.value.modifiedDate).format("YYYY年M月D日")), 1)
                              ])
                            ])
                          ], 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", {
                      class: "my-record-item-header",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo('Treatment')))
                    }, [
                      _createElementVNode("div", _hoisted_26, [
                        _cache[14] || (_cache[14] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_treatment.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("myRecord_card_title_treatment")), 1)
                      ]),
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "my-record-item-header-arrow" }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      (!treatment.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.$t("myRecord_card_label_treatment_initial")), 1))
                        : (treatment.value.treatmentValue === 5)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("p", _hoisted_30, _toDisplayString(treatment.value?.treatmentName), 1),
                              _createElementVNode("p", _hoisted_31, [
                                _cache[16] || (_cache[16] = _createElementVNode("img", {
                                  src: "/server/necs/images/stethoscope_24dp_5F6368_FILL1_wght400_GRAD0_opsz24.png",
                                  alt: ""
                                }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(treatment.value.diseaseName) + _toDisplayString(_ctx.$t("treatment_label_disease_treatment")), 1)
                              ]),
                              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("treatment_label_note")), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("p", _hoisted_34, [
                                  _cache[17] || (_cache[17] = _createElementVNode("img", {
                                    src: "/server/necs/images/icon_treatment_medicine.svg",
                                    alt: ""
                                  }, null, -1)),
                                  _createElementVNode("span", _hoisted_35, _toDisplayString(treatment.value?.treatmentName), 1)
                                ]),
                                (treatment.value?.status)
                                  ? (_openBlock(), _createElementBlock("p", {
                                      key: 0,
                                      class: _normalizeClass(["treatment-detail-label", {
                          suspend: treatment.value.status === _unref(TreatmentStatus).Suspend,
                          finish: treatment.value.status === _unref(TreatmentStatus).Finish,
                          resume: treatment.value.status === _unref(TreatmentStatus).Resume,
                        }])
                                    }, _toDisplayString(getTreatmentStatusOption(treatment.value.status)
                            .display_name), 3))
                                  : _createCommentVNode("", true)
                              ]),
                              (treatment.value?.detail)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(treatment.value.detail), 1))
                                : _createCommentVNode("", true),
                              (treatment.value?.diseaseName)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                                    _cache[18] || (_cache[18] = _createElementVNode("img", {
                                      src: "/server/necs/images/stethoscope_24dp_5F6368_FILL1_wght400_GRAD0_opsz24.png",
                                      alt: ""
                                    }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(treatment.value.diseaseName) + _toDisplayString(_ctx.$t("myRecord_card_label_disease_name")), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("p", _hoisted_40, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("myRecord_card_label_start")), 1),
                                    _createElementVNode("span", _hoisted_41, _toDisplayString(treatment.value?.startDate
                            ? _unref(dayjs)(treatment.value.startDate).format("YYYY年M月D日")
                            : _ctx.$t("treatment_label_no_date")), 1)
                                  ]),
                                  _cache[19] || (_cache[19] = _createElementVNode("span", null, "～", -1)),
                                  (shouldShowStatusChangedDate(treatment.value?.status))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_42, [
                                        _createTextVNode(_toDisplayString(getStatusChangedDateLabel(treatment.value?.status)), 1),
                                        _createElementVNode("span", _hoisted_43, _toDisplayString(getStatusChangedDateText(treatment.value)), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_44, [
                                  _cache[20] || (_cache[20] = _createElementVNode("img", {
                                    src: "/server/necs/images/icon_update_time.svg",
                                    alt: ""
                                  }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(treatment.value.modifiedDate).format("YYYY年M月D日")), 1)
                                ])
                              ])
                            ], 64)),
                      (hasMoreTreatments.value)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 3,
                            class: "treatment-other-count",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (goTo('Treatment')))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("myRecord_card_label_other")), 1),
                            _createElementVNode("span", null, _toDisplayString(hiddenTreatmentCount.value), 1),
                            _createTextVNode(_toDisplayString(_ctx.$t("myRecord_card_label_item")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("myRecord_heading_title_basic")), 1),
                      _createElementVNode("img", {
                        src: "/server/necs/images/icon_info.svg",
                        alt: "",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (infoModal.open('basic')))
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("myRecord_card_label_first_time")), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "my-record-item-header",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (goTo('DiagnosisProcess')))
                    }, [
                      _createElementVNode("div", _hoisted_51, [
                        _cache[21] || (_cache[21] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_diagnosis_process.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t("myRecord_card_title_details")), 1)
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "my-record-item-header-arrow" }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("ul", _hoisted_54, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(diagnosis.value, (item, i) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "diagnosis-process-list-item",
                            key: i
                          }, [
                            _createElementVNode("p", _hoisted_55, [
                              (item.hasRecord)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_56))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(item.hasRecord
                          ? _ctx.$t("myRecord_card_label_complete")
                          : _ctx.$t("myRecord_card_label_incomplete")), 1)
                            ]),
                            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "sp-only" }, "：", -1)),
                            _createElementVNode("p", _hoisted_57, _toDisplayString(item.diseaseName), 1)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t("myRecord_card_label_edit_possible")), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _cache[24] || (_cache[24] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_exercise_routine.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.$t("myRecord_card_title_exercise_habit")), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "exercise-routine-header-edit",
                        onClick: handleExerciseHabitModalOpen
                      }, [
                        _cache[25] || (_cache[25] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_edit_exercise_routine.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$t("myRecord_card_button_collect")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      (!exerciseHabit.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(_ctx.$t("myRecord_card_label_exercise_initial")), 1))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("p", _hoisted_67, _toDisplayString(exerciseHabitText.value), 1),
                            _createElementVNode("p", _hoisted_68, [
                              _cache[26] || (_cache[26] = _createElementVNode("img", {
                                src: "/server/necs/images/icon_update_time.svg",
                                alt: ""
                              }, null, -1)),
                              _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(exerciseHabit.value.modifiedDate).format("YYYY年M月D日")), 1)
                            ])
                          ], 64))
                    ])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createVNode(Footer, {
          "scroll-target": componentId,
          "active-menu": activeMenu
        })
      ])
    ]),
    (infoModal.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("button", {
                type: "button",
                class: "modal-close",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (infoModal.close && infoModal.close(...args)))
              }, _cache[27] || (_cache[27] = [
                _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("img", {
                  class: "popup-contents-img",
                  src: infoModal.image,
                  alt: "治療"
                }, null, 8, _hoisted_74),
                _createElementVNode("p", _hoisted_75, _toDisplayString(infoModal.title), 1),
                _createElementVNode("p", _hoisted_76, _toDisplayString(infoModal.content), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("button", {
                  type: "button",
                  class: "modal-button-next",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (infoModal.close && infoModal.close(...args)))
                }, _toDisplayString(_ctx.$t("myRecord_popup_button_close")), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showExerciseHabitModal.value)
      ? (_openBlock(), _createBlock(ExerciseHabitModal, {
          key: 1,
          exerciseRoutineOptionId: exerciseHabit.value?.exerciseRoutineOptionId,
          onFetchInfo: fetchMyRecords,
          onClose: handleExerciseHabitModalClose
        }, null, 8, ["exerciseRoutineOptionId"]))
      : _createCommentVNode("", true),
    (errorDialog.show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 2 }, errorDialog, {
          onOk: errorDialog.close,
          onCancel: errorDialog.close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})